module.exports = __webpack_public_path__ + "assets/img/70e646ef493acc965fe3570c76f1a40a.webp";